import React from 'react'
import { Notification } from 'is24-corecss'
import { useTranslation } from 'react-i18next'

export function MissingRequiredDataNotification() {
  const { t } = useTranslation()

  return (
    <Notification
      type='info'
      size='small'
      variant='flat'
      title=''
      message={t('wizard.screen.basicInfo.price.recommendedNotification.missingRequiredData')}
    />
  )
}
